import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from "../UserContext";
import axios from 'axios';
import { Box, Avatar, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LabeledTextField from './LabeledTextField';
import DrawerComponent from './common/DrawerComponent';


const Profile = () => {
  const { user_id } = useContext(UserContext);
  const [employee, setEmployees] = useState([]);
  const [avatar, setAvatar] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    role: '',
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const fetchemployee = async () => {
    try {
      const response = await axios.get(`api/employees?user_id=${user_id}`);
      setEmployees(response.data);
    } catch (error) {
      console.error('Error fetching employees', error);
    }
  };

  useEffect(() => {
    fetchemployee();
  }, []);

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(URL.createObjectURL(file));
    }
  };

  const handleEditClick = (emp) => {
    setSelectedEmployee(emp);
    setFormData({
      first_name: emp.first_name,
      last_name: emp.last_name,
      role: emp.role,
      username: emp.username,
      password: emp.password
    });
    setOpen(true); // Open the drawer
  };

  const handleClose = () => {
    setOpen(false); // Close the drawer
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `api/employee/update?id=${selectedEmployee.id}`,
        formData
      );
      console.log(response.data);
      fetchemployee(); // Refresh the employee list
      setOpen(false); // Close the drawer after successful update
    } catch (error) {
      console.error('Error updating employee', error);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword); // Toggle password visibility
  };

  return (
    <div style={{ marginTop: "50px" }}>
      {/* Avatar with Upload Button */}
      <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" marginBottom={3}>
        <Avatar
          alt="User Avatar"
          src={avatar || 'https://via.placeholder.com/150'}
          sx={{ width: 150, height: 150 }}
        />
        <Button
          variant="contained"
          component="label"
          sx={{ marginLeft: 2, marginTop: 2, background: "#1bafbc" }}
        >
          Upload Avatar
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleAvatarChange}
          />
        </Button>
      </Box>

      {/* Employee Table */}
      <TableContainer sx={{ padding: "0 50px" }}>
        <Table sx={{ minWidth: 550 }} aria-label="employee table">
          <TableHead sx={{ background: "#1bafbc" }}>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Password</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employee?.map((emp, index) => (
              <TableRow key={index}>
                <TableCell>{emp.first_name}</TableCell>
                <TableCell>{emp.last_name}</TableCell>
                <TableCell>{emp.role}</TableCell>
                <TableCell>{emp.username}</TableCell>
                <TableCell>{emp.password}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEditClick(emp)} color="primary">
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Edit Employee Drawer */}
      <DrawerComponent
        open={open}
        onClose={handleClose}
        title="Edit Employee"
      >
        <LabeledTextField
          label="First Name"
          name="first_name"
          value={formData.first_name}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <LabeledTextField
          label="Last Name"
          name="last_name"
          value={formData.last_name}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <LabeledTextField
          label="Role"
          name="role"
          value={formData.role}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <LabeledTextField
          label="Username"
          name="username"
          value={formData.username}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
        />
        <LabeledTextField
          label="Password"
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={handleClickShowPassword}
                edge="end"
                aria-label="toggle password visibility"
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            )
          }}
        />
        <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={handleClose} sx={{color:"white",backgroundColor:"#fb7102","&:hover": { backgroundColor: "#fb7102",}}}>Cancel</Button>
          <Button onClick={handleUpdate} sx={{color:"white",backgroundColor:"#fb7102","&:hover": { backgroundColor: "#fb7102",}}}>Save</Button>
        </Box>
      </DrawerComponent>
    </div>
  );
};

export default Profile;

